import React from "react";
import AuthProvider from "./context/AuthContext";
import Home from "./pages/Home";
import SignUp from "./pages/SignUp";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import PrivateRoute from "./pages/PrivateRoute";
import Security from "./pages/Security";
import Setup from "./pages/Setup";
import ForgotPassword from "./pages/ForgotPassword";
import PersonalInformation from "./pages/PersonalInformation";
import EmailVerification from "./pages/EmailVerification";
import GettingStarted from "./pages/GettingStarted";
import Invitation from "./pages/mentor/Invitation";
import FindMentor from "./pages/FindMentor";
import MentorProfile from "./pages/mentor/MentorProfile";
import FourZeroFour from "./pages/FourZeroFour";
import SetupMentor from "../src/pages/mentor/SetupMentor";
import VerifyEmail from "../src/pages/mentor/VerifyEmail";
import MentorDashboard from "./pages/mentor/MentorDashboard";
import AccessDenied from "./pages/AcessDenied";
import PersonalInfoMentor from "../src/pages/mentor/PersonalInfoMentor";
import ProfileStatus from "./pages/mentor/ProfileStatus";
import InviteMentors from "./pages/mentor/InviteMentors";
import FAQ from "./components/FAQ";
import BecomeMentor from "./pages/BecomeMentor";
import FeedbackSupport from "./pages/FeedbackSupport";

function App() {
  return (
    <Router>
      <AuthProvider>
        <Switch>
          <Route exact path="/" component={Home} />
          <Route path="/signup" component={SignUp} />
          <Route path="/login" component={Login} />
          <Route path="/faq" component={FAQ} />
          <Route path="/become-mentor" component={BecomeMentor} />
          <PrivateRoute exact path="/member/dashboard/" component={Dashboard} />
          <PrivateRoute
            exact
            path="/mentor/dashboard/"
            component={MentorDashboard}
          />
          <Route path="/member/verify-email" component={EmailVerification} />
          <Route path="/mentor/verify-email" component={VerifyEmail} />
          <PrivateRoute
            exact
            path="/member/info"
            component={PersonalInformation}
          />
          <PrivateRoute
            exact
            path="/mentor/info"
            component={PersonalInfoMentor}
          />
          <PrivateRoute
            exact
            path="/mentor/profile-status"
            component={ProfileStatus}
          />
          <PrivateRoute exact path="/login-and-security" component={Security} />
          <PrivateRoute exact path="/mentor/invite" component={InviteMentors} />
          <PrivateRoute
            exact
            path="/feedback-and-support"
            component={FeedbackSupport}
          />
          <PrivateRoute exact path="/member/setup" component={Setup} />
          <PrivateRoute exact path="/mentor/setup" component={SetupMentor} />
          <PrivateRoute exact path="/bad-request" component={AccessDenied} />
          <Route path="/forgot-password" component={ForgotPassword} />
          <Route path="/getting-started" component={GettingStarted} />
          <Route path="/invitation" component={Invitation} />
          <Route path="/mentors" component={FindMentor} />
          <Route exact path="/mentor/:username" component={MentorProfile} />
          <Route path="/404" component={FourZeroFour} />
        </Switch>
      </AuthProvider>
    </Router>
  );
}

export default App;
